export const PDF_FOOTER_PLACEHOLDER =
 "Acreos\n1 Rue Claude Chappe, 57050 METZ\nTel : 01 02 03 04 05\nmail : acreos@acreos.eu site acreos.eu\nTVA XXXXXXX, Capital : XXXXXXXX EUR";
export const FOOTER_LINE_COUNT = 5;
export const FOOTER_LIGN_MAX_LENGHT = 50;
